import { Routes, Route } from 'react-router'
import Layout from './components/Layout'
import Home from './pages/Home'
import PessoasMigrantes from './pages/PessoasMigrantes'
import PessoasTuristas from './pages/PessoasTuristas'
import ConsequenciasEImpacto from './pages/ConsequenciasEImpacto'
import ApoioAPAV from './pages/ApoioAPAV'
import Direitos from './pages/Direitos'
import InformacoesUteis from './pages/InformacoesUteis'
import Glossario from './pages/Glossario'
import NotFound from './pages/NotFound'

function App() {
    return (
        <Layout>
            <Routes>
                <Route path="/"                        element={<Home />} />
                <Route path="/pessoas-migrantes"       element={<PessoasMigrantes />} />
                <Route path="/pessoas-turistas"        element={<PessoasTuristas />} />
                <Route path="/consequencias-e-impacto" element={<ConsequenciasEImpacto />} />
                <Route path="/apoio-apav"              element={<ApoioAPAV />} />
                <Route path="/direitos"                element={<Direitos />} />
                <Route path="/informacoes-uteis"       element={<InformacoesUteis />} />
                <Route path="/glossario"               element={<Glossario />} />
                <Route path="*"                        element={<NotFound />} />
            </Routes>
        </Layout>
    )
}

export default App
